var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "hide-overflow", attrs: { flat: "", height: "100%" } },
    [
      _c(
        "v-toolbar",
        { attrs: { dark: "", color: "grey darken-2" } },
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: {
                text: "",
                disabled:
                  _vm.progressiSelezionati.length <= 0 || !_vm.formValido,
              },
              on: {
                click: function ($event) {
                  _vm.dialog = true
                },
              },
            },
            [_vm._v(" Avanti "), _c("v-icon", [_vm._v("mdi-forward")])],
            1
          ),
        ],
        1
      ),
      _c(
        "Loading",
        {
          attrs: {
            visible: _vm.loading,
            message: "Caricamento dati...",
            pageType: 2,
            templateType: _vm.loadTemplateCorrente,
          },
        },
        [
          _vm.righeInviabili.length > 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    "padding-left": "1rem",
                    "padding-right": "1rem",
                  },
                },
                [
                  _c(
                    "v-form",
                    {
                      model: {
                        value: _vm.formValido,
                        callback: function ($$v) {
                          _vm.formValido = $$v
                        },
                        expression: "formValido",
                      },
                    },
                    _vm._l(_vm.righeInviabili, function (riga) {
                      return _c(
                        "v-card",
                        { key: riga.idRiga, staticClass: "riga-card" },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticStyle: { "padding-top": "0.5rem" },
                              attrs: { "primary-title": "" },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      _c("v-flex", { attrs: { xs12: "" } }, [
                                        _c(
                                          "strong",
                                          [
                                            _c("v-checkbox", {
                                              staticStyle: { margin: "0" },
                                              attrs: {
                                                "hide-details": "",
                                                label: `
                      Ordine ${riga.rigaSpedizione.progressoSpedizione.ordineNumero} /
                      Linea ${riga.rigaSpedizione.progressoSpedizione.ordineLinea}
                    `,
                                                value:
                                                  riga.lavorazioneSpedizione.id,
                                              },
                                              model: {
                                                value: _vm.progressiSelezionati,
                                                callback: function ($$v) {
                                                  _vm.progressiSelezionati = $$v
                                                },
                                                expression:
                                                  "progressiSelezionati",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("v-flex", { attrs: { xs12: "" } }, [
                                        _c(
                                          "h3",
                                          {
                                            attrs: {
                                              "data-test":
                                                "descrizione-spedizione",
                                            },
                                          },
                                          [_vm._v(_vm._s(riga.desc))]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-container",
                                    { attrs: { "grid-list-md": "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _vm._l(
                                            riga.rigaSpedizione.qtaTaglie,
                                            function (qta, indexTaglia) {
                                              return [
                                                riga.rigaSpedizione
                                                  .qtaTaglieStatoIniziale[
                                                  indexTaglia
                                                ] > 0
                                                  ? _c(
                                                      "v-flex",
                                                      {
                                                        key: indexTaglia,
                                                        attrs: { xs1: "" },
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            type: "number",
                                                            rules: [
                                                              _vm
                                                                .regoleValidazione
                                                                .maggioreUgualeZero,
                                                              _vm.regoleValidazione.minoreStatoIniziale(
                                                                riga
                                                                  .rigaSpedizione
                                                                  .qtaTaglieStatoIniziale[
                                                                  indexTaglia
                                                                ]
                                                              ),
                                                            ],
                                                            label: `Taglia ${riga.rigaSpedizione.tipoTaglie[indexTaglia]}`,
                                                          },
                                                          model: {
                                                            value:
                                                              riga
                                                                .rigaSpedizione
                                                                .qtaTaglie[
                                                                indexTaglia
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                riga
                                                                  .rigaSpedizione
                                                                  .qtaTaglie,
                                                                indexTaglia,
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "riga.rigaSpedizione.qtaTaglie[indexTaglia]",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _c(
                "v-alert",
                {
                  staticClass: "no-risultati-alert",
                  attrs: { type: "info", value: true },
                },
                [
                  _vm._v(
                    "Non ci sono elementi da poter aggiungere alla spedizione."
                  ),
                ]
              ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "600" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          !_vm.spedizioneCreata
            ? _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Generazione spedizione"),
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Numero DDT",
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.numDDT,
                                          callback: function ($$v) {
                                            _vm.numDDT = $$v
                                          },
                                          expression: "numDDT",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("DatePicker", {
                                        model: {
                                          value: _vm.dataDDT,
                                          callback: function ($$v) {
                                            _vm.dataDDT = $$v
                                          },
                                          expression: "dataDDT",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Numero colli",
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.numColli,
                                          callback: function ($$v) {
                                            _vm.numColli = _vm._n($$v)
                                          },
                                          expression: "numColli",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-textarea", {
                                        attrs: {
                                          label: "Note",
                                          hint: "Inserire qui eventuali note DDT",
                                        },
                                        model: {
                                          value: _vm.notaDDT,
                                          callback: function ($$v) {
                                            _vm.notaDDT = $$v
                                          },
                                          expression: "notaDDT",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "darken-1" },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                            },
                          },
                        },
                        [_vm._v("Annulla")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "green darken-1",
                            text: "",
                            disabled: !_vm.datiValidi,
                            loading: _vm.loading,
                          },
                          on: { click: _vm.creaSpedizione },
                        },
                        [_vm._v("Crea spedizione")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Spedizione creata"),
                  ]),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "darken-1" },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                              _vm.spedizioneCreata = false
                            },
                          },
                        },
                        [_vm._v("Chiudi")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary" },
                          on: { click: _vm.stampaSpedizione },
                        },
                        [_vm._v("Stampa")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            disabled: "",
                            tooltip: "",
                            color: "secondary",
                          },
                        },
                        [_vm._v("Esporta")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }